import { BarLoader } from 'react-spinners'
import PropTypes from 'prop-types'

const DashboardLoading = ({ isLoading }) => (
  <BarLoader
    css={{ position: 'absolute', zIndex: 20 }}
    height={4}
    width={'100%'}
    color={'#326edc'}
    loading={isLoading}
  />
)
DashboardLoading.propTypes = {
  isLoading: PropTypes.bool,
}
export default DashboardLoading
